import LicensesSearch from '@common/licenses';
import SpecialtiesSearch from '@common/specialties';

$(function () {
    $('.read-more').on('click', function () {
        const $btn = $(this);
        // Lock the speed of the animation by the content height so it remains
        // constant, regardless of content.
        const delay = $('.expanded-content').height() * 2;

        if ($btn.hasClass('show-less')) {
            $btn.removeClass('show-less').text('Read More');
            $btn.closest('.intro').find('.expanded-content')
                .removeClass('more').addClass('less');
            $('.expanded-content.less').slideUp(delay);
        } else {
            $btn.addClass('show-less').text('Read Less');
            $btn.closest('.intro').find('.expanded-content')
                .removeClass('less').addClass('more');
            $('.expanded-content.more').slideDown(delay);
        }
    });

    LicensesSearch.init();
    SpecialtiesSearch.init();
});
